export default __webpack_public_path__ + "static/media/dashboard_min.b74522ee.svg";